<template>

<app-page :title="title" :back="{name: 'Organisation', params: { id: this.$route.params.organisation }}">

    <app-panel :title="$constants.userTypeText[model.type]" :is-padded="true">

        <app-input type="text" label="First name" placeholder="Enter first name" v-model="model.firstname" />
        <app-input type="text" label="Last name" placeholder="Enter last name" v-model="model.lastname" />
        <app-input type="text" label="E-mail address" placeholder="Enter e-mail address" v-model="model.email" />
        <app-input type="password" label="Password" placeholder="Enter password" v-model="model.password" v-if="isNew" />

    </app-panel>

    <app-panel title="Change Password" :is-collapsed="!model.changepassword" :is-padded="true" v-if="!isNew" v-on:toggle="model.changepassword = $event" :toggled="model.changepassword" has-toggle="Change password">

        <app-input type="password" label="Password" placeholder="Enter password" v-model="model.password" />
        <app-input type="password" label="Confirm Password" placeholder="Enter password again" v-model="model.confirmpassword" />

    </app-panel>

    <app-actions>

        <app-button text="Save" :is-disabled="!canSave" :is-loading="is.saving" v-on:click.native="onSaveClick" />
        <app-button text="Delete" v-if="canDelete" :is-loading="is.deleting" theme="red" v-on:click.native="onDeleteClick" />

    </app-actions>

</app-page>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'

export default {

    mixins: [mixForm],

    data: function() {

        return {
            api: ['organisation', this.$route.params.organisation, 'users'],
            modelExtend: {
                changepassword: false,
                confirmpassword: '',
                password: ''
            },
            redirect: {
                new: {
                    name: 'Organisation',
                    params: {
                        id: this.$route.params.organisation
                    }
                },
                delete: {
                    name: 'Organisation',
                    params: {
                        id: this.$route.params.organisation
                    }
                }
            },
        }

    },

    validations: function() {

        var validations = {
            model: {
                firstname: { 
                    required 
                },
                lastname: { 
                    required 
                },
                email: { 
                    email, 
                    required 
                }
            }
        }

        if (this.requirePassword) {
        
            validations.model.password = { 
                required,
                minLength: minLength(6)
            }
        
        }

        if (this.requirePasswordConfirm) {
        
            validations.model.confirmpassword = { 
                sameAs: sameAs(function() { return this.model.password })
            }
        
        }

        return validations

    },

    computed: {

        requirePassword: function() {
        
            return this.isNew || this.model.changepassword

        },

        requirePasswordConfirm: function() {
        
            return this.model.changepassword

        },
    
        title: function() {

            return (this.isNew) ? 'Add User' : 'Edit User'
        
        }
    
    }

}

</script>

<style scoped>

</style>
